import React from 'react';
import { Frame } from '$ui/Integrations/Frame';
import { Failed, Repair, Success } from '$ui/Integrations/Screens';
import { SyncState } from '$types/integrations';
import { repair, useWorkflow } from '$ui/Integrations/Workflows/workflows';

interface Props {
    auth: () => Promise<void>;
    sync: () => void;
    onFinish: () => void;
    syncState: SyncState;
}

// TODO: Refactor this when introducing a new integration
export const OutlookRepair = (props: Props) => {
    const { auth, sync, onFinish, syncState } = props;

    const { matches, onSync, onSignIn } = useWorkflow({
        healthyState: 'healthy',
        workflow: repair,
        syncState,
        auth,
        sync
    });

    return (
        <Frame
            integration="Outlook"
            mode="Repair"
            next={matches('healthy')}
            back={false}
            last
            onExit={onFinish}
            onFinish={onFinish}
            onNext={() => null}
            onBack={() => null}
        >
            {matches('repair') && (
                <Repair
                    integration="Outlook"
                    onSignIn={onSignIn}
                    signingIn={matches('repair.signingIn')}
                />
            )}

            {matches('healthy') && (
                <Success
                    integration="Outlook"
                    onSync={onSync}
                    repaired
                    syncing={matches('healthy.syncing')}
                />
            )}

            {matches('failed') && (
                <Failed
                    integration="Outlook"
                    mode="repair"
                    onSignIn={onSignIn}
                    signingIn={matches('failed.signingIn')}
                />
            )}
        </Frame>
    );
};
